// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  APIEndpoint: 'https://api.dse.isdm.org.in',
  socket_EndPoint: 'https://chatapp.dse.isdm.org.in',
  imageBasePath:'assets/images/',
  userDefaultProfilePic: 'avatar-default.jpg',
  userDefaultGroupPic: 'team-avtars.png',

  svgBasePath:'assets/images/svg/',
  default_Pic_project: 'project_icon.svg',
  default_Pic_calender: 'calender_icon.svg',
  default_Pic_guftagu: 'guftagu_icon.svg',
  default_Pic_course: 'course_icon.svg',
  default_Pic_profile: 'profile_icon.svg',
  groupProfilePicSize: 20,
  client__id:'740524272057-71qhplgke03mgrctjreajsn5ravi0ndg.apps.googleusercontent.com',
  customOrigin: 'https://qa.edu-collab.com',
  rgbDefaultTheme: `236, 95, 95`,
  rgbaDefaultTheme: `rgba(236, 95, 95, 0.8)`,
  hexDefaultTheme: '#ec5f5f',
  defaultLogo: '../../assets/images/logo.png',
  defaultLogoLarge: '../../assets/images/logo-large.png',
  envName:'localhost',
};


// 'https://api.edu-collab.com',  production
//  APIEndpoint: 'https://api.stage.edu-collab.com', stage
//  "https://api.stage.edu-collab.com",
//  "http://127.0.0.1:5000"
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
